import React, { PureComponent } from 'react'

class SearchWithParam extends PureComponent {
  searchForStores (e) {
    document.activeElement.blur()
    const query = window.document.querySelector('#searchbox').value
    window.location.href = '/stores/search/' + encodeURI(query)
    e.preventDefault()
  }
  render () {
    return (
      <div className='sd-search-container'>
        <div className='sd-panel sc-panel'>
          <div className='sc-search'>
            <h2 className='sc-search-title'>Find a store</h2>
            <form className='sc-search-bar clearfix' type='search' action='/stores/'>
              <input className='sc-search-bar-input form-control' name='search' id='searchbox' placeholder='My town or postcode is...' autoComplete='off' />
              <button className='sc-search-bar-btn btn btn-block' onClick={(e) => this.searchForStores(e)}>
                <span className='sc-search-bar-icon argos-icon icon-UIE-Search' aria-hidden='true' />
                <span className='argos-text sr-only'>Search</span>
              </button>
            </form>
            <div className='sc-option-links'>
              <a href='https://www.argos.ie/webapp/wcs/stores/servlet/ArgosStoreLocatorDB?includeName=StoreLocator&langId=111&storeId=10152' className='link pull-left btn-shop-ie' target='_blank'>Shop Republic Of Ireland</a>
              <a href='/stores/#storeslist' className='link pull-right azs-link'><span className='sr-only'>See all stores from </span> A-Z</a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SearchWithParam



// WEBPACK FOOTER //
// ./src/components/SearchWithParam/SearchWithParam.jsx